export function capitalizeFirstLetter(text: string | null | undefined): string {
  if (!text) return 'N/A';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
